export default __webpack_public_path__ + "static/wealth-management-ce769bda43fc5f4360082ab00d1b97f1.jpg";